{
  "fr": {
    "aiConverter": {
      "alerts": {
        "dialog": {
          "format": "Veuillez marquer les deux interlocuteurs avec **Nom** : au début de la ligne."
        },
        "example": "Voulez-vous un exemple ?",
        "truncatedText": "Votre source dépasse la limite de {limit} caractères et ne peut donc pas être traitée dans son intégralité."
      },
      "buttons": {
        "reuse": "Réutiliser",
        "transform": "Transformer",
        "limitReached": "Limite atteinte",
        "submitForKind": {
          "audio": "Faire lire le texte",
          "dialog": "Créer un dialogue",
          "lecture": "Créer un exposé",
          "podcast": "Créer un podcast",
          "summary": "Créer un résumé",
          "text": "Reconnaître du texte à partir d'une image ou d'un fichier",
          "transcript": "Créer une transcription",
          "translation": "Traduire un texte"
        }
      },
      "confirm": {
        "deleteDocument": {
          "text": "Cette action est irréversible. Le document sera définitivement supprimé de votre historique.",
          "title": "Supprimer le document ?"
        }
      },
      "example": {
        "audio": {
          "text": "Les éléphants vivent en troupeaux. Ceux-ci ne comprennent que des femelles et des jeunes, pas de mâles adultes. Un troupeau est dirigé par une femelle éléphant expérimentée. Elle protège le groupe en montrant qu'elle attaquerait si nécessaire : elle écarte largement ses oreilles et lève sa trompe haut. Les mâles adultes vivent généralement seuls ou en groupes qui se dissolvent et se reforment constamment. Ils ne s'approchent des troupeaux de femelles que pour s'accoupler. Les éléphants sont exclusivement végétariens. Ils préfèrent manger de l'herbe et des feuilles, mais aussi des branches et d'autres plantes. Ils ont besoin d'environ 200 kilogrammes de nourriture par jour. Ils boivent également plus de 100 litres d'eau. Les éléphants dorment moins longtemps que les humains. Ils passent tout leur temps à manger. Pour cela, ils doivent aussi marcher très loin. Bien qu'ils soient lents, ils sont très endurants. C'est pourquoi il est difficile de garder des éléphants dans un zoo, car l'espace y devient vite trop restreint pour eux. Par grande chaleur et pour prendre soin de leur peau, ils aiment prendre un bain ou se projeter de l'eau sur le dos avec leur trompe. En cas de chaleur, ils agitent leurs oreilles pour se rafraîchir un peu. (Source : https://klexikon.zum.de/wiki/Elefanten)"
        },
        "dialog": {
          "dialog": "Entrez ici votre dialogue en marquant les interlocuteurs avec **Nom/Rôle** : au début de la ligne.",
          "text": "**Hôte** : Bonjour ! Comment t'appelles-tu ?\n**Invité** : Je m'appelle Anna. Et toi ?\n**Hôte** : Je m'appelle Max. Enchanté de te rencontrer.\n**Invité** : Moi aussi, je suis ravi."
        },
        "lecture": {
          "prompt": "Concentrez-vous sur l'histoire et le contexte politique de l'Ukraine et expliquez le sujet de manière appropriée pour les élèves de la classe de 11e année.",
          "url": "https://de.wikipedia.org/wiki/Ukraine"
        },
        "podcast": {
          "prompt": "Utilisez un langage simple pour les apprenants de niveau A2. Concentrez-vous sur le monde des adolescents (12-14 ans) et donnez des exemples pertinents pour eux.",
          "url": "https://thewanderbug.com/itinerary-5-days-new-york-city-first-time/"
        },
        "summary": {
          "url": "https://www.bpb.de/kurz-knapp/hintergrund-aktuell/559432/desinformation-und-wahlen/",
          "prompt": "Concentrez-vous sur les faits les plus importants pour les élèves de la classe de 10e année."
        },
        "transcript": {
          "url": "https://www.youtube.com/watch?v=hv0Hz2XMGXA"
        },
        "translation": {
          "text": "La plupart d'entre nous pensent que les manchots sont une espèce polaire, plus à l'aise sur la glace de l'Antarctique que sur les plages de sable, les champs herbeux et les collines des îles Falkland. Mais ces îles incroyables de l'Atlantique Sud abritent cinq espèces de ces fantastiques oiseaux incapables de voler. Les plages de sable des Falkland abritent la plus grande population de manchots papous au monde - plus de 121 000 couples ont été comptés ici lors du dernier recensement en 2010 ! Vivant aux Falkland toute l'année, ces oiseaux de 76 cm de haut sont faciles à reconnaître grâce à la barre blanche qui s'étend sur le dessus de leur tête et à leur bec orange vif. Très rapides en mer, ils nagent jusqu'à 36 km/h lorsqu'ils plongent pour attraper des poissons. Puis, lorsqu'il est temps de retourner à terre, ils surfent sur les vagues avant de trébucher sur la plage. En 1971, il n'y avait que 31 couples reproducteurs de manchots royaux à Volunteer Green sur l'île d'East Falkland, mais aujourd'hui, il y en a plus de 1 500 - c'est la deuxième plus grande colonie de manchots royaux au monde et la plus accessible. Heureusement, c'est là que nous allons ! Des milliers de rois d'un mètre de haut se tiennent ensemble, leurs jeunes à proximité à divers stades de développement. Certains adultes ont des œufs blancs en forme de poire reposant sur leurs pieds, d'autres ont des poussins gris nouveau-nés nichés entre leurs plumes ventrales. Les poussins plus âgés ont développé leur duvet brun duveteux, qui ressemble un peu à de la laine de mouton. Nous écoutons l'appel bruyant des adultes alors qu'ils pointent leur bec vers le ciel et trompettent, annonçant leur présence. C'est comme si les adultes élégants et droits posaient pour des photos, leurs beaux cous et becs orange-jaune brillant au soleil. Source : https://www.natgeokids.com/uk/discover/animals/birds/penguins-of-the-falkland-islands/"
        }
      },
      "headings": {
        "config": "Quels contenus l'IA doit-elle utiliser ?",
        "input": "Que doit faire l'IA pour vous ?",
        "output": "Résultat"
      },
      "help": {
        "website": "Exemple : https://fobizz.com/was-ist-fobizz/"
      },
      "hints": {
        "audio": "Astuce : Vous pouvez télécharger un fichier par glisser-déposer. Nous prenons en charge les fichiers .mp3, .mp4, .mp4a ou .wav jusqu'à {limit}MB.",
        "copyright": "Remarque : Assurez-vous de respecter les droits d'auteur lors de l'utilisation de contenus tiers.",
        "image": "Astuce : Vous pouvez télécharger un fichier par glisser-déposer. Nous prenons en charge les fichiers .jpeg, .png jusqu'à {limit}MB.",
        "materialGeneration": "Matériel en cours de création...",
        "noInputKindSelected": "Veuillez choisir un type d'entrée.",
        "pdf": "Astuce : Vous pouvez télécharger un fichier par glisser-déposer. Nous prenons en charge les fichiers .pdf, .doc, .docx, .ppt et .pptx jusqu'à {limit}MB.",
        "processingProgressMessage": "Le texte est converti en audio...",
        "submitting": "Conversion en cours",
        "text": "Astuce : Vous pouvez entrer jusqu'à 5000 caractères.",
        "video": "Astuce : Vous pouvez télécharger un fichier par glisser-déposer. Nous prenons en charge les fichiers .mp4, .mp4v, .avi ou .mkv jusqu'à 100MB."
      },
      "labels": {
        "additionalInfo": "Informations supplémentaires et public cible",
        "dialog": "Entrée de dialogue",
        "language": "Langue",
        "outputLanguage": "Langue de sortie",
        "outputText": "Texte de sortie",
        "source": "Source",
        "text": "Entrée de texte",
        "transcript": "Transcription",
        "url": "URL",
        "voice": "Voix",
        "voicePlural": "Voix",
        "secondVoice": "Deuxième voix"
      },
      "links": {
        "download": "Télécharger",
        "openInChat": "Ouvrir dans le Chat IA"
      },
      "materialExports": {
        "assistant": "Assistant IA",
        "classroom_screen": "Tableau numérique",
        "pinboard": "Tableau d'affichage",
        "survey": "Sondage",
        "text_document": "Document texte",
        "web_page": "Page web",
        "worksheet": "Fiche d'exercices"
      },
      "sourceKinds": {
        "audio": "Audio",
        "dialog": "Dialogue",
        "lecture": "Exposé",
        "podcast": "Podcast",
        "summary": "Résumé",
        "text": "Texte",
        "transcript": "Transcription",
        "translation": "Traduction"
      },
      "options": {
        "inputKinds": {
          "audio": {
            "icon": "bi-file-music",
            "title": "Fichier audio"
          },
          "image": {
            "icon": "bi-file-image",
            "title": "Image"
          },
          "pdf": {
            "icon": "bi-file-earmark-text",
            "title": "Fichier"
          },
          "text": {
            "icon": "bi-file-text",
            "title": "Texte"
          },
          "video": {
            "icon": "bi-film",
            "title": "Fichier vidéo"
          },
          "website": {
            "icon": "bi-globe",
            "title": "Site web"
          },
          "youtube": {
            "icon": "bi-youtube",
            "title": "YouTube"
          }
        },
        "languages": {
          "auto": "Reconnaître automatiquement"
        }
      },
      "paragraphs": {
        "voiceDefaultText": "Bonjour, comment ça va ? Je suis votre assistant IA fobizz."
      },
      "placeholders": {
        "additionalInfo": "Ajoutez des informations sur le public cible et mettez en avant les aspects de contenu qui vous tiennent particulièrement à cœur.",
        "website": "Entrez l'URL du site web..."
      },
      "statusMessages": {
        "combine_audio_chunks": "Le fichier audio est en cours de création {progress}%",
        "extract_text": "Le texte est extrait...",
        "generate_audio_file": "L'audio est en cours de création {progress}%",
        "generate_dialog": "Le dialogue est en cours de lecture {progress}%",
        "generate_lecture": "L'exposé est en cours de création...",
        "generate_podcast": "Le podcast est en cours de création...",
        "processing_text_chunks": "Les sections de texte sont en cours de traitement {progress}%",
        "summarize_text": "Le texte est en cours de résumé...",
        "translate_text": "Le texte est en cours de traduction...",
        "video_downloading": "La vidéo est en cours de téléchargement {progress}%",
        "video_processing": "La vidéo est en cours de traitement {progress}%"
      }
    }
  }
}
